import { Injectable } from '@angular/core';
import { GolfEvent } from '../models/GolfEvent';
import { LeagueWeek } from '../models/LeagueWeek';
import { LeagueRound } from '../models/LeagueRound';
import { Player } from '../models/Player';
import { firstValueFrom } from 'rxjs';
import { CreateGolfEventRequest } from '../models/creategolfeventrequest';
import { HttpClient } from '@angular/common/http';
import { CreateLeagueWeekRequest } from '../models/createleagueweekrequest';
import { ConfigurationService } from './configuration.service';
import { GolfEventField } from '../models/golfeventfield';

@Injectable({
  providedIn: 'root'
})
export class GolfEventService {

  constructor(private http:HttpClient, private configService:ConfigurationService) { 
    this.baseUrl = this.configService.getApiEndpoint();
  }

  baseUrl:string;

  async createEvent(request:CreateGolfEventRequest):Promise<number> {
    let endpoint = `${this.baseUrl}/golfevent`;
    let result = await firstValueFrom(this.http.post<number>(endpoint, request));
    return result;
  }

  async createLeagueWeek(request:CreateLeagueWeekRequest):Promise<number> {
    let endpoint = `${this.baseUrl}/leagueweek`;
    let result = await firstValueFrom(this.http.post<number>(endpoint, request));
    return result;
  }

  async searchEvents():Promise<Array<GolfEvent>> {
    let endpoint = `${this.baseUrl}/golfevents`;
    let result = await firstValueFrom(this.http.post<GolfEvent[]>(endpoint, {}));
    return result;
  }

  async getLeagueWeeks(eventId:number):Promise<Array<LeagueWeek>> {
    let endpoint = `${this.baseUrl}/leagueweeks`;
    let weeks = await firstValueFrom(this.http.post<LeagueWeek[]>(endpoint, { golfEventId: eventId }));
    return weeks;
  }

  async getGolfEventById(eventId:number):Promise<GolfEvent> {
    let events = await this.searchEvents();
    let eventsFound = events.filter(evt => evt.id.toString() === eventId.toString()); //I HATE the toString() here but there is a bug I can't get resolved.
    return eventsFound[0];
  }

  async searchField(eventId:number):Promise<Array<GolfEventField>> {
    let endpoint = `${this.baseUrl}/field`;
    let result = await firstValueFrom(this.http.post<GolfEventField[]>(endpoint, { golfEventId: eventId }));
    return result;
  }

  async updateFieldHasPaid(fieldId:number, hasPaid:boolean):Promise<void> {
    let endpoint = `${this.baseUrl}/haspaid`;
    await firstValueFrom(this.http.patch(endpoint, { fieldId: fieldId, hasPaid: hasPaid }));
  }

  generatePaymentLink(event:GolfEvent):string {
    let link = this.configService.getPaymentServiceLink();
    let username = this.configService.getPaymentServiceUsername();

    link = link.replace('{username}', username);
    const note = encodeURIComponent(event.eventName);//.replace(/\+/g, '%20');
    link = link.replace('{tag}', note);
    link += "&amount=" + event.entryFee;
    return link;
  }

  async getPlayersByEventId(eventId:number):Promise<Player[]> {
    let players:Array<Player> = [{
          id:1,
          firstName: "John",
          lastName: "Strawn"
      },
      {
          id:2,
          firstName: "Jason",
          lastName: "Krumbholz"
      },
      {
          id:3,
          firstName: "Paul",
          lastName: "Kingrey"
      },
      {
          id:4,
          firstName: "Zach",
          lastName: "Gassmann"
      },
      {
          id:5,
          firstName: "Mike",
          lastName: "Hofland"
      },
      {
          id:6,
          firstName: "Rocky",
          lastName: "Robbins"
      },
      {
          id:7,
          firstName: "Alan",
          lastName: "Downe"
      },
      {
          id:8,
          firstName: "Eric",
          lastName: "Davis"
      },
    ];

    return players;
  }

  async getLeagueRounds(leagueWeekId:number):Promise<Array<LeagueRound>> {
    let rounds:Array<LeagueRound> = [];

    if(leagueWeekId === 7)
      rounds = this.getWeek7Rounds();
    
    return rounds;
    
  }

  private getWeek7Rounds():Array<LeagueRound>{
    return [
      { id: 1, leagueWeekId: 7, playerFirstName: "Jason", playerLastName: "Krumbholz", playerId: 2, score: 31, isDeleted: false },
      { id: 2, leagueWeekId: 7, playerFirstName: "Jason", playerLastName: "Krumbholz", playerId: 2, score: 28, isDeleted: false },
      { id: 3, leagueWeekId: 7, playerFirstName: "Jason", playerLastName: "Krumbholz", playerId: 2, score: 31, isDeleted: false },
      { id: 4, leagueWeekId: 7, playerFirstName: "John", playerLastName: "Strawn", playerId: 1, score: 31, isDeleted: false },
      { id: 5, leagueWeekId: 7, playerFirstName: "John", playerLastName: "Strawn", playerId: 1, score: 30, isDeleted: false },
      { id: 6, leagueWeekId: 7, playerFirstName: "Jason", playerLastName: "Krumbholz", playerId: 2, score: 34, isDeleted: false },
    ];
  }
}